import HttpQuery from "@mnjsplatform/data/lib/api/HttpQuery";

class HomeApi {
    static loadInitialData() {
        let hq = new HttpQuery();
        return hq.makeApiCall("CarrierHome/Ping");
    }

    static changePassword(oldPassword, newPassword1, newPassword2) {
        let hq = new HttpQuery();
        return hq.makeApiCallPost("CarrierHome/ChangePassword", {oldPassword, newPassword1, newPassword2});
    }

    static quitSession() {
        let hq = new HttpQuery();
        return hq.makeApiCall("CarrierHome/QuitSession");
    }
}

export default HomeApi
